var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge"},[_c('span',{staticClass:"text",style:({ borderBottom: ("1px solid " + _vm.color) })},[_c('ellipsis',{attrs:{"length":40,"tooltip":""}},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }